(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseaseDeleteController',LeadHospitalizationDiseaseDeleteController);

    LeadHospitalizationDiseaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadHospitalizationDisease'];

    function LeadHospitalizationDiseaseDeleteController($uibModalInstance, entity, LeadHospitalizationDisease) {
        var vm = this;
        vm.leadHospitalizationDisease = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadHospitalizationDisease.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
